import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../store'

type LicenseState = {
    token: string
    url: string
    name: string
    language: string
} | null

const initialState: LicenseState = null as LicenseState

const licenseSlice = createSlice({
    name: 'license',
    initialState,
    reducers: {
        setLicense: (state, { payload: license }: PayloadAction<Exclude<LicenseState, null>>) =>
            license,
        clearLicense: () => initialState,
    },
})

export const { setLicense, clearLicense } = licenseSlice.actions

export const selectLicense = (state: RootState) => state.license

export default licenseSlice.reducer
